
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
require('./filters');
require('./translations');
require('./tooltips');

// uncomment the following line to debug Vue performance
// Vue.config.performance = true;

// Leaflet map
import { L, LMap, LTileLayer, LMarker } from 'vue2-leaflet';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// frontend: search components
Vue.component('search-form', require('./components/frontend/search/SearchForm.vue').default);
Vue.component('search-results-list', require('./components/frontend/search/SearchResultsList.vue').default);
Vue.component('search-input', require('./components/frontend/search/SearchInput.vue').default);
Vue.component('search-filter-panel', require('./components/frontend/search/SearchFilterPanel.vue').default);
Vue.component('search-filter-card', require('./components/frontend/search/SearchFilterCard.vue').default);
Vue.component('search-filter-link', require('./components/frontend/search/SearchFilterLink.vue').default);
Vue.component('date-range-filter-card', require('./components/frontend/search/DateRangeFilterCard.vue').default);

// frontend: sidebar menu
Vue.component('sidebar-menu', require('./components/frontend/SidebarMenu.vue').default);

// frontend: sidebar left with content right
Vue.component('content-with-sidebar', require('./components/frontend/ContentWithSidebar.vue').default);

// frontend: records count
Vue.component('records-count', require('./components/frontend/RecordsCount.vue').default);

// frontend: record list table
Vue.component('record-list-table-frontend', require('./components/frontend/RecordListTableFrontend.vue').default);
Vue.component('collapsible-table-row', require('./components/frontend/CollapsibleTableRow.vue').default);

// frontend: records filter
Vue.component('starts-with-filter', require('./components/frontend/filter/StartsWithFilter.vue').default);
Vue.component('checkbox-filter-group', require('./components/frontend/filter/CheckboxFilterGroup.vue').default);
Vue.component('checkbox-filter', require('./components/frontend/filter/CheckboxFilter.vue').default);
Vue.component('dropdown-filter', require('./components/frontend/filter/DropdownFilter.vue').default);
Vue.component('reset-filters', require('./components/frontend/filter/ResetFilters.vue').default);

// frontend: openseadragon viewer
Vue.component('osd-viewer', require('./components/frontend/OsdViewer.vue').default);
Vue.component('print-preview-image', require('./components/frontend/PrintPreviewImage.vue').default);

// frontend: map view
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('leaflet-map', require('./components/frontend/map/LeafletMap.vue').default);
Vue.component('location-of-documents-map-view', require('./components/frontend/map/LocationOfDocumentsMapView.vue').default);

// frontend: locations view
Vue.component('location-records-view', require('./components/frontend/locations/LocationRecordsView.vue').default);
Vue.component('locations-accordion', require('./components/frontend/locations/LocationsAccordion.vue').default);
Vue.component('location-card', require('./components/frontend/locations/LocationCard.vue').default);
Vue.component('location-type-display', require('./components/frontend/locations/LocationTypeDisplay.vue').default);

// frontend: home slider
Vue.component('home-slider', require('./components/frontend/HomeSlider.vue').default);

// utility components
Vue.component('date-range-slider', require('./components/common/DateRangeSlider.vue').default);
Vue.component('image-view', require('./components/common/ImageView.vue').default);
Vue.component('loading-indicator', require('./components/common/LoadingIndicator.vue').default);
Vue.component('truncate-text', require('./components/common/TruncateText.vue').default);
Vue.component('modal-dialog', require('./components/common/ModalDialog.vue').default);

// frontend: modal dialogs
Vue.component('print-button', require('./components/frontend/PrintButton.vue').default);
Vue.component('print-dialog', require('./components/frontend/PrintDialog.vue').default);
Vue.component('download-dialog', require('./components/frontend/DownloadDialog.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.config.performance = true
const app = new Vue({
    el: '#app'
});
